import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    GAMES: "Game Development",
    FULLSTACK: "Full-Stack",
    CHALLENGES: "Challenges",
  };

  const projectsData = [
    {
      title: "Alien Invaders",
      projectInfo:
        "A classic arcade game recreation featuring enemy movement patterns, collision detection, and progressive difficulty scaling. Built with Python and Pygame, this project demonstrates core game development concepts.",
      technologies: "Python, Pygame, Game State Management, Sprite Rendering",
      industry: "Game Development, Education",
      url: {
        name: "GitHub Repository",
        link: "https://github.com/a-maystorov/alien-invaders",
      },
      repos: {
        frontend: {
          name: "View on GitHub",
          link: "https://github.com/a-maystorov/alien-invaders",
        },
      },
      socialLinks: {
        github: "https://github.com/a-maystorov",
        mail: "mailto:alkin971@gmail.com",
      },
      thumbImage: null,
      placeholderColor: "#4A90E2",
      placeholderHeight: "320px",
      sliderImages: ["demos/alien-invaders-demo.gif"],
      categories: ["Game Development"],
      features: [
        "Enemy movement patterns with synchronized fleet behavior",
        "Collision detection system for projectiles and enemies",
        "Progressive difficulty scaling as player advances",
        "Game state management with scoring system",
        "Sprite rendering and animation handling",
        "Input handling for responsive player controls",
      ],
    },
    {
      title: "Asteroids",
      projectInfo:
        "A modern recreation of the classic Asteroids arcade game built with Python and Pygame. Features physics-based movement, asteroid fragmentation mechanics, and vector-based collision detection.",
      technologies: "Python, Pygame, Vector Mathematics, Physics Simulation",
      industry: "Game Development, Education",
      url: {
        name: "GitHub Repository",
        link: "https://github.com/a-maystorov/asteroids",
      },
      repos: {
        frontend: {
          name: "View on GitHub",
          link: "https://github.com/a-maystorov/asteroids",
        },
      },
      socialLinks: {
        github: "https://github.com/a-maystorov",
        mail: "mailto:alkin971@gmail.com",
      },
      thumbImage: null,
      placeholderColor: "#E74C3C",
      placeholderHeight: "280px",
      sliderImages: ["demos/asteroids-demo.gif"],
      categories: ["Game Development"],
      features: [
        "Physics-based ship movement with realistic acceleration",
        "Vector-based movement and rotation calculations",
        "Asteroid fragmentation system with splitting mechanics",
        "Collision detection using polygon shapes",
        "Application of trigonometry for rotation and movement",
        "Progressive difficulty with increasing asteroid speed",
      ],
    },
    {
      title: "Pong",
      projectInfo:
        "A web-based implementation of the classic Pong game using vanilla JavaScript and CSS. Features DOM manipulation, real-time rendering, ball physics, and paddle controls for web platforms.",
      technologies: "JavaScript, CSS3, HTML5, DOM Manipulation",
      industry: "Game Development, Web Development",
      url: {
        name: "Play on GitHub Pages",
        link: "https://a-maystorov.github.io/pong/",
      },
      repos: {
        frontend: {
          name: "View on GitHub",
          link: "https://github.com/a-maystorov/pong",
        },
      },
      socialLinks: {
        github: "https://github.com/a-maystorov",
        mail: "mailto:alkin971@gmail.com",
      },
      thumbImage: null,
      placeholderColor: "#2ECC71",
      placeholderHeight: "360px",
      sliderImages: ["demos/pong-demo.gif"],
      categories: ["Game Development"],
      features: [
        "Web-based game using CSS positioning and animations",
        "Real-time rendering without Canvas API",
        "Ball physics with realistic collision detection",
        "Responsive paddle controls with smooth movement",
        "Score tracking and win condition detection",
        "Demonstrates cross-platform game development skills",
      ],
    },
    {
      title: "Tic-Tac-Toe",
      projectInfo:
        "An intelligent Tic-Tac-Toe game featuring both player-vs-player and player-vs-AI modes. The AI implements strategic decision-making with win condition detection and algorithmic thinking.",
      technologies: "Python, Pygame, AI Logic, Game Theory",
      industry: "Game Development, AI",
      url: {
        name: "GitHub Repository",
        link: "https://github.com/a-maystorov/tic-tac-toe",
      },
      repos: {
        frontend: {
          name: "View on GitHub",
          link: "https://github.com/a-maystorov/tic-tac-toe",
        },
      },
      socialLinks: {
        github: "https://github.com/a-maystorov",
        mail: "mailto:alkin971@gmail.com",
      },
      thumbImage: null,
      placeholderColor: "#9B59B6",
      placeholderHeight: "300px",
      sliderImages: ["demos/ttt-demo.gif"],
      categories: ["Game Development"],
      features: [
        "Two game modes: Player vs Player and Player vs AI",
        "Strategic AI opponent with decision-making logic",
        "Win condition detection algorithm",
        "Basic artificial intelligence implementation",
        "Understanding of game theory principles",
        "Clean game state management",
      ],
    },
    {
      title: "Flow Forge",
      projectInfo:
        "A modern task management platform with drag-and-drop kanban boards, real-time collaboration, and AI assistance. Built with React/TypeScript frontend and Express/MongoDB backend.",
      technologies:
        "React, TypeScript, Express, MongoDB, Socket.IO, JWT, Mantine UI",
      industry: "Productivity, Project Management",
      url: {
        name: "View Project",
        link: "https://flow-forgez.netlify.app/welcome",
      },
      repos: {
        frontend: {
          name: "Frontend Repo (flow-forge-fe)",
          link: "https://github.com/a-maystorov/flow-forge-fe",
        },
        backend: {
          name: "Backend Repo (flow-forge-core)",
          link: "https://github.com/a-maystorov/flow-forge-core",
        },
      },
      socialLinks: {
        github: "https://github.com/a-maystorov",
        mail: "mailto:alkin971@gmail.com",
      },
      thumbImage: null,
      placeholderColor: "#5B7C99",
      placeholderHeight: "290px",
      sliderImages: [
        "images/projects/flow-forge/ff-1.png",
        "images/projects/flow-forge/ff-2.png",
        "images/projects/flow-forge/ff-3.png",
        "images/projects/flow-forge/ff-4.png",
      ],
      categories: ["Full-Stack"],
      features: [
        "Drag-and-drop kanban boards with customizable workflows",
        "Real-time collaboration using Socket.IO",
        "JWT authentication with permanent/temporary sessions",
        "Rich text editor for task descriptions",
        "Mobile-responsive design with dark mode support",
        "RESTful API with TypeScript type safety",
      ],
    },
    {
      title: "Ideally",
      projectInfo:
        "A modern project management and idea sharing platform built with React and Firebase. Enables teams to collaborate effectively by managing projects, sharing ideas, and tracking progress in real-time.",
      technologies: "React, Firebase",
      industry: "Project Management, Team Collaboration",
      url: {
        name: "ideally-project-management.web.app",
        link: "https://ideally-project-management.web.app/login",
      },
      repos: {
        frontend: {
          name: "Github Repository (Ideally)",
          link: "https://github.com/a-maystorov/ideally",
        },
      },
      socialLinks: {
        github: "https://github.com/a-maystorov",
        mail: "mailto:alkin971@gmail.com",
      },
      thumbImage: null,
      placeholderColor: "#E67E22",
      placeholderHeight: "340px",
      sliderImages: [
        "images/projects/ideally/ideally-1.png",
        "images/projects/ideally/ideally-2.png",
      ],
      categories: ["Full-Stack"],
      features: [
        "User authentication with Firebase Auth",
        "Real-time project updates with Firestore",
        "File sharing capabilities with Firebase Storage",
        "Team collaboration through comments and discussions",
        "Custom dashboards for project overview",
        "Customizable user profiles with avatars",
      ],
    },
    {
      title: "GameSpot",
      projectInfo:
        "A full-featured game rental management system with inventory tracking, customer management, and rental processing. Built with React/TypeScript frontend and Node.js/Express/MongoDB backend.",
      technologies:
        "React, TypeScript, Node.js, Express, MongoDB, JWT, Bootstrap",
      industry: "Entertainment, Retail Management",
      url: {
        name: "gamespotz.netlify.app",
        link: "https://gamespotz.netlify.app/games",
      },
      repos: {
        frontend: {
          name: "Frontend Repo (gamespot-client)",
          link: "https://github.com/a-maystorov/gamespot-client",
        },
        backend: {
          name: "Backend Repo (gamespot-api)",
          link: "https://github.com/a-maystorov/gamespot-api",
        },
      },
      socialLinks: {
        github: "https://github.com/a-maystorov",
        mail: "mailto:alkin971@gmail.com",
      },
      thumbImage: null,
      placeholderColor: "#16A085",
      placeholderHeight: "310px",
      sliderImages: [
        "images/projects/gamespot/gs-1.png",
        "images/projects/gamespot/gs-2.png",
        "images/projects/gamespot/gs-3.png",
        "images/projects/gamespot/gs-4.jpeg",
      ],
      categories: ["Full-Stack"],
      features: [
        "Game inventory management with detailed information tracking",
        "Customer database with profile management",
        "Complete rental processing system with automated fee calculation",
        "Role-based access control with secure JWT authentication",
        "Responsive design optimized for both desktop and mobile devices",
        "97%+ test coverage with Jest and Supertest",
      ],
    },

    {
      title: "Product Feedback App",
      projectInfo:
        "A fully responsive and interactive product feedback application built with React. Allows users to manage product feedback through a clean interface with complete CRUD functionality, filtering, and sorting capabilities.",
      technologies:
        "React, React Router, React Select, HTML5, CSS3, JavaScript",
      industry: "User Experience, Product Management",
      url: {
        name: "a-maystorov.github.io/product-feedback-app",
        link: "https://a-maystorov.github.io/product-feedback-app/",
      },
      repos: {
        frontend: {
          name: "GitHub Repository",
          link: "https://github.com/a-maystorov/product-feedback-app",
        },
      },
      socialLinks: {
        github: "https://github.com/a-maystorov",
        mail: "mailto:alkin971@gmail.com",
      },
      thumbImage: null,
      placeholderColor: "#8E44AD",
      placeholderHeight: "295px",
      sliderImages: [
        "images/projects/product-feedback/feedback-1.jpeg",
        "images/projects/product-feedback/feedback-2.jpeg",
        "images/projects/product-feedback/feedback-3.jpeg",
        "images/projects/product-feedback/feedback-4.jpeg",
      ],
      categories: ["Challenges"],
      features: [
        "Complete CRUD operations for product feedback requests",
        "Advanced filtering by category (UI, UX, Enhancement, Bug, Feature)",
        "Smart sorting by most/least upvotes and comments",
        "Interactive comment and reply system",
        "Upvoting system to prioritize feedback",
        "Responsive design optimized for all devices",
      ],
    },
    {
      title: "Clock App",
      projectInfo:
        "A sophisticated, fully responsive clock application that displays time and location data based on the user's IP address, featuring dynamic UI changes based on time of day and detailed time information.",
      technologies: "HTML5, CSS3, JavaScript, External APIs",
      industry: "Web Utilities, User Interface Design",
      url: {
        name: "a-maystorov.github.io/clock-app",
        link: "https://a-maystorov.github.io/clock-app/",
      },
      repos: {
        frontend: {
          name: "GitHub Repository",
          link: "https://github.com/a-maystorov/clock-app",
        },
      },
      socialLinks: {
        github: "https://github.com/a-maystorov",
        mail: "mailto:alkin971@gmail.com",
      },
      thumbImage: null,
      placeholderColor: "#34495E",
      placeholderHeight: "330px",
      sliderImages: [
        "images/projects/clock-app/clock-1.jpeg",
        "images/projects/clock-app/clock-2.png",
        "images/projects/clock-app/clock-3.jpeg",
      ],
      categories: ["Challenges"],
      features: [
        "Real-time clock display with automatic updates",
        "Dynamic UI changes based on time of day (day/night modes)",
        "Geolocation integration for location-based information",
        "Expandable panel with detailed time information",
        "Random programming quotes with refresh option",
        "Multiple API integrations (WorldTimeAPI, FreeGeoIP)",
      ],
    },
    {
      title: "Rock, Paper, Scissors, Lizard, Spock",
      projectInfo:
        "An interactive implementation of the popular game from 'The Big Bang Theory' TV show. Features a clean UI, local storage for score persistence, and responsive design for all devices.",
      technologies: "HTML5, CSS3, JavaScript, LocalStorage API",
      industry: "Web Games, Interactive Entertainment",
      url: {
        name: "a-maystorov.github.io/rock-paper-scissors-lizard-spock",
        link: "https://a-maystorov.github.io/rock-paper-scissors-lizard-spock/",
      },
      repos: {
        frontend: {
          name: "GitHub Repository",
          link: "https://github.com/a-maystorov/rock-paper-scissors-lizard-spock",
        },
      },
      socialLinks: {
        github: "https://github.com/a-maystorov",
        mail: "mailto:alkin971@gmail.com",
      },
      thumbImage: null,
      placeholderColor: "#C0392B",
      placeholderHeight: "305px",
      sliderImages: [
        "images/projects/rps/rps-1.jpeg",
        "images/projects/rps/rps-2.jpeg",
        "images/projects/rps/rps-3.jpeg",
      ],
      categories: ["Challenges"],
      features: [
        "Interactive gameplay with visual feedback",
        "Extended game rules with Lizard and Spock options",
        "Score persistence using localStorage",
        "CSS Grid implementation for complex pentagon layout",
        "Responsive design optimized for all devices",
        "Dynamic game states with smooth transitions",
      ],
    },
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
    });

    // Set a flag that isotope is ready
    setimagesLoaded(1);

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (isotope.current && imagesLoaded) {
      if (filterKey === "*") {
        isotope.current.arrange({ filter: `*` });
      } else {
        // Convert spaces to hyphens for CSS class compatibility
        const filterClass = filterKey.replace(/\s+/g, "-");
        isotope.current.arrange({ filter: `.${filterClass}` });
      }
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-1" : "")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Portfolio
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              My Projects
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      project.categories.join(" ").replace(/\s+/g, "-")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded position-relative">
                        {project.placeholderColor ? (
                          // Show colored placeholder for game projects
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              backgroundColor: project.placeholderColor,
                              minHeight: project.placeholderHeight || "280px",
                              position: "relative",
                            }}
                          >
                            <div className="text-center p-4">
                              <h3
                                className="text-white fw-600 mb-2"
                                style={{ fontSize: "1.8rem" }}
                              >
                                {project.title}
                              </h3>
                              <p
                                className="text-white-50 mb-0"
                                style={{ fontSize: "0.9rem" }}
                              >
                                {project.technologies
                                  .split(",")
                                  .slice(0, 2)
                                  .join(" /")
                                  .trim()}
                              </p>
                            </div>
                          </div>
                        ) : (
                          // Show regular image for non-game projects
                          <img
                            onLoad={() => {
                              setimagesLoaded(imagesLoaded + 1);
                            }}
                            className="img-fluid d-block portfolio-image"
                            src={project.thumbImage}
                            alt={project.title}
                          />
                        )}
                        <div
                          className="portfolio-overlay"
                          style={{ zIndex: 2 }}
                        >
                          <a
                            className="popup-ajax stretched-link"
                            href="#!"
                            onClick={(e) => {
                              e.preventDefault();
                              setSelectedProjectDetails(projectsData[index]);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          >
                            <span className="visually-hidden">
                              View Project
                            </span>
                          </a>
                          <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                            <span className="text-light">
                              {project.categories[0]}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
